
let wf = require('waterfall')

wf.KeyPair.prototype.parseFromJSON = function(jstr) {
    let obj = JSON.parse(jstr)
    for (let k of wf.KeyPair) wf.KeyPair[k] = obj[k]
}
function NewKeyPairFromJSON(jstr) {
    let kp = new wf.KeyPair()
    let obj = JSON.parse(jstr)
    // console
    for (let k in kp) kp[k] = obj[k]
    return kp
}

// 后端定义
// type KeyPair struct {
//     PrivateKey       string
//     Passphrase       string // 经 EncryptPassword 加密后密钥的密码
//     PublicKey        string
//     SshAuthorizedKey string
// }

class SshVerifyHostKeyData {
    Hostname = ""
    Remote = ""

    // the key's type, e.g. "ssh-rsa".
    PublicKeyType = ""

    // FingerprintLegacyMD5 returns the user presentation of the key's
    // fingerprint as described by RFC 4716 section 4.
    FingerprintLegacyMD5 = ""

    // FingerprintSHA256 returns the user presentation of the key's
    // fingerprint as unpadded base64 encoded sha256 hash.
    // This format was introduced from OpenSSH 6.8.
    // https://www.openssh.com/txt/release-6.8
    // https://tools.ietf.org/html/rfc4648#section-3.2 (unpadded base64 encoding)
    FingerprintSHA256 = ""

    constructor(hostname, remote, publicKeyType, publicKey, fingerprintLegacyMD5, fingerprintSHA256) {
        this.Hostname = hostname
        this.Remote = remote
        this.PublicKeyType = publicKeyType
        this.PublicKey = publicKey
        this.FingerprintLegacyMD5 = fingerprintLegacyMD5
        this.FingerprintSHA256 = fingerprintSHA256
    }

    static NewFromJson(str) {
        let obj = JSON.parse(str)
        let data = new SshVerifyHostKeyData(obj.Hostname, obj.Remote, obj.PublicKeyType, obj.PublicKey, obj.FingerprintLegacyMD5, obj.FingerprintSHA256)
        return data
    }
}

class SshKnownHost {
    Raw = ""
    Marker = ""
    Hosts = []
    SshAuthorizedKey = ""
    FingerprintLegacyMD5 = ""
    FingerprintSHA256 = ""
    Comment = ""
    Rest = ""
    Err = ""

    constructor(raw, marker, hosts, sshAuthorizedKey, fingerprintLegacyMD5, fingerprintSHA256, comment, rest, err) {
        this.Raw = raw
        this.Marker = marker
        this.Hosts = hosts
        this.SshAuthorizedKey = sshAuthorizedKey
        this.FingerprintLegacyMD5 = fingerprintLegacyMD5
        this.FingerprintSHA256 = fingerprintSHA256
        this.Comment = comment
        this.Rest = rest
        this.Err = err
    }

    toSearchString() {
        let hostStr = ""
        if (this.Hosts && this.Hosts.length > 1) {
            for (let host of this.Hosts) {
                hostStr += host
            }
        }
        return `${this.Raw}${this.Marker}${hostStr}${this.SshAuthorizedKey}${this.FingerprintLegacyMD5}${this.FingerprintSHA256}${this.Comment}${this.Rest}${this.Err}`
    }

    static NewFromJson(str) {
        let obj = JSON.parse(str)
        return new SshKnownHost(obj.Raw, obj.Marker, obj.Hosts, obj.SshAuthorizedKey, obj.FingerprintLegacyMD5, obj.FingerprintSHA256, obj.Comment, obj.Rest, obj.Err)
    }
    static NewFromApiData(data) {
        let obj = data
        return new SshKnownHost(obj.Raw, obj.Marker, obj.Hosts, obj.SshAuthorizedKey, obj.FingerprintLegacyMD5, obj.FingerprintSHA256, obj.Comment, obj.Rest, obj.Err)
    }
}

export default {
    Session: wf.Session,
    KeyPair: wf.KeyPair,

    NewKeyPairFromJSON,
    SshVerifyHostKeyData,
    SshKnownHost,
}
